import React, {useEffect, useState} from 'react';
import {
  View,
  Image,
  Text,
  StyleSheet,
  StatusBar,
  Animated,
  ActivityIndicator,
} from 'react-native';
import {Colors} from '../theme/colors';

interface SplashScreenProps {
  onFinish: () => void;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({onFinish}) => {
  const [fadeAnim] = useState(new Animated.Value(0));

  useEffect(() => {
    // Fade in the logo
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 800,
      useNativeDriver: true,
    }).start();

    // Auto-finish after 3 seconds
    const timer = setTimeout(onFinish, 3000);
    return () => clearTimeout(timer);
  }, [fadeAnim, onFinish]);

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor={Colors.primary} />
      
      {/* Centered LaViola Logo */}
      <View style={styles.content}>
        <Animated.View style={{opacity: fadeAnim}}>
          <Image
            source={{uri: 'https://cdn.laviola.it/laviola/logo-payoff.png'}}
            style={styles.logo}
            resizeMode="contain"
          />
        </Animated.View>
        
        {/* Loading Indicator */}
        <ActivityIndicator
          size="large"
          color={Colors.textOnPrimary}
          style={styles.loader}
        />
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <Text style={styles.footerText}>Powered by</Text>
        <Text style={styles.companyName}>ICOA SRL</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 280,
    height: 120,
  },
  loader: {
    marginTop: 30,
  },
  footer: {
    position: 'absolute',
    bottom: 40,
    alignItems: 'center',
  },
  footerText: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
  },
  companyName: {
    color: Colors.textOnPrimary,
    fontSize: 14,
    fontWeight: '600',
    marginTop: 4,
  },
});
